import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { useConsent } from "../lib/consent";

// Set REACT_APP_INSTAGRAM_URL / REACT_APP_FACEBOOK_URL to the brand's profile pages.
const INSTAGRAM_URL = process.env.REACT_APP_INSTAGRAM_URL || "https://www.instagram.com/";
const FACEBOOK_URL = process.env.REACT_APP_FACEBOOK_URL || "https://www.facebook.com/";

export default function Footer() {
  const { openPreferences } = useConsent();
  return (
    <footer className="border-t-[0.5px] border-black/10 mt-20 py-10 bg-white" data-testid="footer">
      <div className="container-x flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className="logo text-2xl">Inkstead</div>
          <p className="text-sm text-black/60 mt-2">A community platform for the tattoo world.</p>
        </div>
        <div className="text-sm text-black/60 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
          <nav className="flex gap-6" aria-label="Legal">
            <Link to="/terms" className="hover:text-black hover:underline" data-testid="footer-terms">Terms</Link>
            <Link to="/privacy" className="hover:text-black hover:underline" data-testid="footer-privacy">Privacy Policy</Link>
            <button type="button" onClick={openPreferences} className="hover:text-black hover:underline" data-testid="footer-cookie-prefs">Cookie Preferences</button>
          </nav>
          <div className="flex gap-4">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Inkstead on Instagram" className="hover:text-black" data-testid="footer-instagram"><Instagram className="w-5 h-5"/></a>
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Inkstead on Facebook" className="hover:text-black" data-testid="footer-facebook"><Facebook className="w-5 h-5"/></a>
          </div>
          <span>© {new Date().getFullYear()} Inkstead</span>
        </div>
      </div>
    </footer>
  );
}
